import { tr } from "../i18n/LanguageContext";
import { useEffect, useState } from "react";

// Event languages live on the server (GET /api/event-languages); fetched once per page load.
let cache = null;
let pending = null;

const load = () => {
  if (!pending) {
    pending = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/event-languages`)
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => (cache = list))
      .catch(() => {
        pending = null;
        return [];
      });
  }
  return pending;
};

export function useEventLanguages() {
  const [eventLanguages, setEventLanguages] = useState(cache || []);
  useEffect(() => {
    if (!cache) load().then((list) => setEventLanguages(list));
  }, []);
  const getLanguageLabel = (value) => eventLanguages.find((l) => l.value === value)?.label ? tr(eventLanguages.find((l) => l.value === value).label) : value;
  return { eventLanguages, getLanguageLabel };
}
